<footer>
    <div class="wrapper">
        <ul class="footer-menu">
            <li><a href="https://wrwa.gov.uk/waste-authority/">About Us</a></li>
            <li><a href="https://wrwa.gov.uk/contact/">Contact</a></li>
            <li><a href="https://wrwa.gov.uk/accessibility-statement/">Accessibility Statement</a></li>
            <li><a href="https://wrwa.gov.uk/terms-and-conditions/">Terms &amp; Conditions</a></li>
            <li> <a href="https://wrwa.gov.uk/privacy-policy/">Privacy Policy</a> </li>
            <li><a href="https://wrwa.gov.uk/cookie-policy/">Cookie Policy</a></li>
            <li><a href="https://wrwa.gov.uk/disclaimer/">Disclaimer</a></li>
            <li><a href="https://wrwa.gov.uk/sitemap_index.xml">Site Map</a></li>
        </ul>
        <ul class="footer-social">
            <li><a target="_blank"
                    href="https://www.facebook.com/pages/category/Government-Organization/Western-Riverside-Waste-Authority-1695703610719729/"
                    aria-label="social media facebook"><fa-icon [icon]="faFacebook"></fa-icon></a></li>
            <li><a target="_blank" href="https://twitter.com/wrwarecycling?lang=en"
                    aria-label="social media facebook"><fa-icon [icon]="faX"></fa-icon></a></li>
        </ul>
    </div>
</footer>